import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/popover/style";
import _Popover from "vant/es/popover";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "core-js/modules/es.array.push.js";
import Vue from 'vue';
import get from '@/api/get';
import getTime from '../utils/time';
import * as _code from '../utils/code';
import messagereply from '@/components/messagereply';
import { debounce } from 'lodash';
import numberFormat from '@/utils/numberFormat';
import levelIcon from '@/components/task/levelIcon.vue';
Vue.use(_Tab);
Vue.use(_Tabs);
Vue.use(_ActionSheet);
Vue.use(_Popover);
export default {
  components: {
    [_Icon.name]: _Icon,
    [_Button.name]: _Button,
    messagereply,
    levelIcon
  },
  props: {
    commentListData: {
      type: Object,
      default: () => {}
    },
    detailId: {
      type: String,
      default: ''
    },
    sharePage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultImg: this.$store.state.gameType != 1 ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp' : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      replyCommentList: [],
      messagereply: {},
      isLike: '',
      isLikeInside: '',
      badClickFlag: '',
      username: '用户名',
      show: false,
      actions: window.user.weixcode ? [{
        name: '举报'
      }] : [{
        name: '举报'
      }, {
        name: '分享'
      }],
      publishedCon: '',
      publishTime: '發布於2天前',
      replayNum: '3',
      sortType: '倒序',
      showPopover: false,
      sortActions: [{
        text: '正序'
      }, {
        text: '倒序'
      }, {
        text: '热点排序'
      }],
      sortOffset: [20, 0],
      msg: '评论评论评论评论评论评论评论评论评论评论',
      serverName: '区服1',
      likeNum: '10',
      msgTime: '3分钟前',
      currentReplyList: [],
      imgThumb: '',
      //图片压缩关键字
      messagereplyFlag: true
    };
  },
  mounted() {
    this.$preview.on('close', (e, item) => {
      //图片大图关闭事件
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
    });
    this.init();
    this.messagereply.likeNum = numberFormat(this.messagereply.likeNum);
    this.messagereply.replyNum = numberFormat(this.messagereply.replyNum);
  },
  watch: {
    commentListData(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.messagereplyFlag = true;
      this.imgThumb = this.$store.state.imgThumb;
      this.messagereply = JSON.parse(JSON.stringify(this.commentListData));
      let _obj = [];
      _obj[0] = this.messagereply;
      getTime(_obj);
      if (this.messagereply.replyCommentList) {
        getTime(this.messagereply.replyCommentList);
        // 二级评论添加发帖人id，楼主身份标识
        let messagereplyName = this.messagereply.memberNickName;
        this.messagereply.replyCommentList.forEach((v, i) => {
          v.floorNum = this.messagereply.floorNum; //将父级楼层赋值给子级评论
          v.postsPosterId = this.messagereply.postsPosterId;
          v.czFlag = messagereplyName == v.replyMemberNickName ? true : false;
        });
        this.replyCommentList = JSON.parse(JSON.stringify(this.messagereply.replyCommentList));
      } else {
        this.replyCommentList = [];
      }
      if (this.messagereply.pictures) {
        this.messagereply.pictures = JSON.parse(this.messagereply.pictures);
        this.$previewRefresh();
      }
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //扩展点击
    vanActionFlag(item) {
      this.$emit('vanActionFlag', 2, item);
    },
    //去用户主页
    goUserPage(id) {
      this.$emit('goUserPage', id);
    },
    //点击评论回复
    replyUser(item, poster) {
      this.$emit('inputFocus', this.messagereply, item, poster);
    },
    //跳转回复列表
    goAllReply() {
      if (this.$store.state.loginStatus == 0) {
        this.$store.commit('changeLoginShow', true);
      } else {
        let _this = this;
        if (this.messagereply.replyNum >= 10) {
          this.$emit('allReplyChang', true, this.messagereply.id, this.messagereply.postsPosterId);
        } else {
          get.replyList(this.messagereply.id).then(res => {
            let data = res.data;
            if (data.code == 0) {
              getTime(data.data.list);
              data.data.list.forEach((v, i) => {
                v.floorNum = this.messagereply.floorNum; //将父级楼层赋值给子级评论
                v.postsPosterId = this.messagereply.postsPosterId;
                v.czFlag = v.replyMemberNickName == _this.messagereply.memberNickName ? true : false;
              });
              this.replyCommentList = data.data.list;
              this.messagereplyFlag = false;
            } else {
              this.errorMessage(data.code);
            }
          });
        }
      }
    },
    changeReplyCommentList(item) {
      this.replyCommentList.push(item);
    },
    onSelect(item) {
      this.show = false;
      _Toast(item.name);
    },
    onCancel() {
      _Toast('取消');
    },
    onSelectAction(action) {
      _Toast(action.text);
    },
    //评论点踩
    badClick: debounce(function () {
      get.commentBadClick(this.messagereply.id).then(res => {
        let data = res.data;
        if (data.code == 0) {
          this.messagereply.isBad = !this.messagereply.isBad;
          if (this.messagereply.isBad && this.messagereply.isLike) {
            this.lickClick();
          }
        } else {
          // this.errorMessage(data.code);
        }
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    likeChang() {
      this.messagereply.isLike = !this.messagereply.isLike;
      this.messagereply.isLike ? this.messagereply.likeNum++ : this.messagereply.likeNum--;
      if (this.messagereply.isBad && this.messagereply.isLike) {
        this.badClick();
      }
    },
    lickClick: debounce(function () {
      if (this.$route.path == '/postShare') return;
      get.commentLikeClick(this.messagereply.id).then(res => {
        let data = res.data;
        if (data.code == 0) {
          if (data.message == '点赞成功') {
            this.$refs.level1_lickbtn.style.width = '.8rem';
            this.$refs.level1_lickbtn.style.height = '.8rem';
            this.$refs.level1_lickbtn.style.backgroundPosition = 'right';
            this.$refs.level1_lickbtn.style.transition = `background .6s steps(28)`;
            setTimeout(() => {
              this.$refs.level1_lickbtn.style.width = '.8rem';
              this.$refs.level1_lickbtn.style.height = '.8rem';
              this.$refs.level1_lickbtn.style.backgroundPosition = 'left';
              this.$refs.level1_lickbtn.style.width = '.8rem';
              this.$refs.level1_lickbtn.style.height = '.8rem';
              this.$refs.level1_lickbtn.style.backgroundPosition = 'left';
              this.$refs.level1_lickbtn.style.transition = `none`;
              this.likeChang();
            }, 600);
          } else {
            this.likeChang();
          }
        } else {
          this.errorMessage(data);
        }
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    imgClick(flag, imgList) {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
      // let imgArr = [];
      // imgList.id = 0;
      // imgArr.push(imgList);
      // this.$emit("imgClick", flag, imgArr, 0);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        _Toast(msg);
      }
    }
  }
};